export function shouldCreateDeviceSession(
  deviceToken: string | null | undefined,
  sessionId: string | null | undefined
): boolean {
  return !deviceToken || !sessionId;
}

export function passwordLoginCredentials(username: string, key: string) {
  return {
    user: { username, key },
    deviceToken: null as string | null,
    sessionId: null as string | null,
  };
}

export function shouldLogoutAfterSessionCheckError(hasDeviceSession: boolean): boolean {
  return hasDeviceSession;
}
